import React from 'react';
import { Link } from "react-router-dom";
import { FaRocket } from 'react-icons/fa';
import BackgroundBeams from '../../components/ui/BackgroundBeams.jsx';
import BackgroundBeams_1 from '../../components/ui/BackgroundBeams_1.jsx';
import HomeAiHero from './home_ai.jsx';


export default function HomeHeroSection({
  glassPanel,
  heroTitle,
  homeDescription,
  ctaLinkProps,
  ctaLabel,
  hideCtaIcon = false,
  docLinkProps,
  main_domain,
  latest_version,
  tipsVipLoading = false,
}) {
  const showEditorialHero =
    main_domain == 'hust' &&
    (latest_version == 3 || latest_version == '3');

  const showHello =
    main_domain == 'hust' &&
    latest_version &&
    latest_version != 1 &&
    latest_version != '1';

  return (
    <>
      {showHello && (
        <>
          {showEditorialHero ? (
            <HomeAiHero
              glassPanel={glassPanel}
            />
          ) : (
            <div className={`${glassPanel} enter-hero`}>
              <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-pink-500/10 to-transparent rounded-full blur-3xl -z-10"></div>
              <div className="relative z-10 flex flex-col items-center text-center py-3 sm:py-5 gap-1 sm:gap-2">
                <img
                  src="https://hust.media/img/icon/home_first_5.png"
                  alt="Hust Media Icon"
                  loading="lazy"
                  className="w-18 h-18 sm:w-20 sm:h-20 object-contain"
                />
                <h1 className="mt-1 text-3xl sm:text-5xl font-black tracking-tight">
                  <span className="bg-gradient-to-r from-white via-pink-200 to-pink-500 bg-clip-text text-transparent filter drop-shadow-lg">
                    Hust Media
                  </span>
                </h1>
                <p className="text-lg sm:text-2xl md:text-3xl text-slate-100 leading-snug font-bold max-w-4xl">
                  Web & Mobile Integration Architecture
                </p>

                <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 pt-1 sm:pt-2">
                  <Link
                    {...ctaLinkProps}
                    className="relative inline-flex w-full sm:w-auto items-center justify-center gap-2 bg-gradient-to-r from-pink-600 to-purple-600 text-white font-semibold text-sm sm:text-base py-2.5 px-6 sm:px-7 rounded-full no-underline shadow-[0_0_20px_rgba(236,72,153,0.4)] shadow-pink-500/50 animate-pulse motion-reduce:animate-none hover:shadow-[0_0_40px_rgba(236,72,153,0.6)] hover:scale-105 transition-all duration-300"
                  >
                    {!hideCtaIcon ? <FaRocket /> : null} {ctaLabel}
                  </Link>
                  <Link
                    {...docLinkProps}
                    className="w-full sm:w-auto px-6 sm:px-7 py-2.5 rounded-full border border-white/20 text-white text-sm sm:text-base no-underline shadow-[0_0_10px_rgba(219,39,119,0.22)] hover:bg-white/10 hover:shadow-[0_0_18px_rgba(219,39,119,0.35)] transition-all font-semibold"
                  >
                    Documentation
                  </Link>
                </div>

                <p className="w-full max-w-5xl pt-2 sm:pt-3 text-sm sm:text-base md:text-lg text-white">
                  This is Hust Media's content hub, where practical guides and reference materials are curated to help you learn and execute correctly.
                </p>
              </div>
            </div>
          )}
        </>
      )}
      {!showHello && (
        <div className={`${glassPanel} enter-hero`}>
          <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-pink-500/10 to-transparent rounded-full blur-3xl -z-10"></div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-6 sm:gap-8 items-center">
            <div className="md:col-span-3 space-y-4 sm:space-y-6">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-black tracking-tight">
                <span className="bg-gradient-to-r from-white via-pink-200 to-pink-500 bg-clip-text text-transparent filter drop-shadow-lg">
                  {heroTitle}
                </span>
              </h1>
              <p className="text-[16px] sm:text-lg text-slate-200 leading-relaxed font-light border-l-4 border-pink-500 pl-4">
                {homeDescription}
              </p>

              <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 pt-1 sm:pt-2">
                <Link
                  {...ctaLinkProps}
                  className="relative inline-flex w-full sm:w-auto items-center justify-center gap-2 bg-gradient-to-r from-pink-600 to-purple-600 text-white font-semibold text-sm sm:text-base py-2.5 px-6 sm:px-7 rounded-full no-underline shadow-[0_0_20px_rgba(236,72,153,0.4)] shadow-pink-500/50 animate-pulse motion-reduce:animate-none hover:shadow-[0_0_40px_rgba(236,72,153,0.6)] hover:scale-105 transition-all duration-300"
                >
                  {!hideCtaIcon ? <FaRocket /> : null} {ctaLabel}
                </Link>
                <Link
                  {...docLinkProps}
                  className="w-full sm:w-auto px-6 sm:px-7 py-2.5 rounded-full border border-white/20 text-white text-sm sm:text-base no-underline shadow-[0_0_10px_rgba(219,39,119,0.22)] hover:bg-white/10 hover:shadow-[0_0_18px_rgba(219,39,119,0.35)] transition-all font-semibold"
                >
                  Documentation
                </Link>
              </div>

            </div>

            <div className="md:col-span-2 relative">
              <div className="block h-[200px] sm:h-[290px] w-full sm:max-w-[390px] ml-auto rounded-xl border border-white/15 bg-slate-900/35 p-3 sm:p-3.5 relative flex flex-col items-center justify-center antialiased overflow-hidden transition hover:border-pink-400/60 hover:bg-slate-900/45">
                <div className="z-10 w-full px-3 text-center text-lg sm:px-5 sm:text-2xl font-bold text-slate-100">
                      Digital Media AI
                </div>
                <BackgroundBeams_1 />
              </div>
            </div>
          </div>
        </div>

      )}
    </>

  );
}
